/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { toast } from "react-toastify";
import axios, { AxiosError } from "axios";
import { ocultarAcoes } from "../../../../services/acesso";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { useLocation } from "react-router-dom";
import TextField from '@mui/material/TextField';
import { GridFilterOperator } from "@mui/x-data-grid";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import BotaoLerCnh, { CnhLida, formatarCpf, validadeCnhParaIso } from "../../../../components/ler-cnh";
import { ApiError, Campo, Locatario, UsuarioLocatario } from "../../../../services/tipos";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { StatusLocatario, TipoFormulario, ESTADOS_BRASIL } from "../../../../services/constantes";
import { FaExchangeAlt, FaIdCard, FaLink, FaMobileAlt, FaSearchLocation, FaSync, FaSyncAlt, FaUser, FaWhatsapp } from "react-icons/fa";
import { Box, Tooltip } from "@mui/material";
import { converterStatusLocatarioParaTexto, handleDownloadFile } from "../../../../services/utilitarios";
import { useFiliais } from "../../../../hooks/useFiliais";
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterIdTenent, obterIntegradoLocaSmartCheck, obterTipoPlano, usuarioTemPermissao } from "../../../../services/seguranca";
import ModalImportacao from "../../../../components/modal-importacao";
import ModalSincronizacao from "../../../../components/locasmartcheck/ModalSincronizacao";
import { CAMPOS_LOCATARIO } from "../../../../services/importacao";

function LocatarioListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const location = useLocation();
    const [estado, setEstado] = useState<string>('');
    const [estados, setEstados] = useState<any[]>([]);
    const [cidades, setCidades] = useState<any[]>([]);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false)
    const [carregando, setCarregando] = useState<boolean>(false);
    const [locatarios, setLocatarios] = useState<Locatario[]>([]);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [mascaraDocumento, setMascaraDocumento] = useState<string>('');
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [documentoCNHRemovido, setDocumentoCNHRemovido] = useState<boolean>(false);
    const [carregandoSelectCidades, setCarregandoSelectCidades] = useState<boolean>(false);
    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [locatarioSelecionado, setLocatarioSelecionado] = useState<Locatario>({} as Locatario);
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState<boolean>(false);
    const [showLoginLocatario, setShowLoginLocatario] = useState<boolean>(false);
    const [isSavingLoginLocatario, setIsSavingLoginLocatario] = useState<boolean>(false);
    const [entidadeUsada, setEntidadeUsada] = useState({} as any);
    const [forcarAtualizacao, setForcarAtualizacao] = useState<boolean>(false);
    const [showModalImportacao, setShowModalImportacao] = useState<boolean>(false);
    const [tipoPlano, setTipoPlano] = useState<'PRO' | 'AVANCADO'>('PRO');
    const [mostrarAvancadoLocatario, setMostrarAvancadoLocatario] = useState(false);
    const [isPessoaJuridica, setIsPessoaJuridica] = useState(false);
    const [integradoAsaas, setIntegradoAsaas] = useState<boolean>(false);
    const [sincronizandoAsaasId, setSincronizandoAsaasId] = useState<string | null>(null);
    const integradoLocaSmartCheck = obterIntegradoLocaSmartCheck(token);
    const [modalSincLocaSmartCheckAberto, setModalSincLocaSmartCheckAberto] = useState<boolean>(false);
    const [exibirModalInativar, setExibirModalInativar] = useState<boolean>(false);
    const [locatarioParaInativar, setLocatarioParaInativar] = useState<Locatario | null>(null);
    const [rowCount, setRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25,
    });

    const statusFilterOperators: GridFilterOperator[] = [
        {
            label: 'contém',
            value: 'contains',
            getApplyFilterFn: (filterItem) => {
                if (!filterItem.value) {
                    return null;
                }
                const filterValue = filterItem.value.toLowerCase();
                return ({ value }) => {
                    const statusText = converterStatusLocatarioParaTexto(value);
                    return statusText ? statusText.toLowerCase().includes(filterValue) : false;
                };
            },
            InputComponent: (props) => (
                <TextField
                    variant="standard"
                    value={props.item.value || ''}
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                    placeholder="Digite para buscar"
                    fullWidth
                    style={{ marginTop: '16px' }}
                />
            ),
        },
        {
            label: 'é igual a',
            value: 'equals',
            getApplyFilterFn: (filterItem) => {
                if (!filterItem.value) {
                    return null;
                }
                const filterValue = filterItem.value.toLowerCase();
                return ({ value }) => {
                    const statusText = converterStatusLocatarioParaTexto(value);
                    return statusText ? statusText.toLowerCase() === filterValue : false;
                };
            },
            InputComponent: (props) => (
                <TextField
                    variant="standard"
                    value={props.item.value || ''}
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                    placeholder="Digite para buscar"
                    fullWidth
                    style={{ marginTop: '16px' }}
                />
            ),
        },
    ];

    const colunas = [
        { field: 'nome', headerName: 'Nome', flex: 1 },
        { field: 'documento', headerName: 'Documento', flex: 1 },
        { field: 'rg', headerName: 'Rg', flex: 1 },
        {
            field: 'kmMedioPorDia', headerName: 'Km médio / Dia', flex: 1, renderCell(params: any) {
                if (!params.row.kmMedioPorDia) {
                    return "Não informado"
                }
            }
        },
        {
            field: 'vencimentoHabilitacao', headerName: 'Venc. Habilitação', flex: 1,
            valueGetter: (params: any) => {
                return new Date(params.value);
            },
            renderCell: (params: any) => {
                const date = new Date(params.value);
                if (isNaN(date.getTime())) {
                    return '';
                }
                return date.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1.2,
            minWidth: 150,
            valueGetter: (params: any) => params.value,
            filterOperators: statusFilterOperators,
            renderCell: (params: any) => {
                const status = params.value;
                const statusText = converterStatusLocatarioParaTexto(status) ?? 'Indefinido';

                let backgroundColor;
                if (status === StatusLocatario.stAtivo) {
                    backgroundColor = '#4CAF50';
                } else if (status === StatusLocatario.stHabilitacaoVencida) {
                    backgroundColor = '#FFC107';
                } else {
                    backgroundColor = '#f44336';
                }

                const labelStyle: React.CSSProperties = {
                    backgroundColor,
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    textAlign: 'center' as 'center',
                    fontSize: '0.75rem',
                    whiteSpace: 'nowrap',
                };

                return (
                    <span style={labelStyle}>
                        {statusText}
                    </span>
                );
            }
        }
        ,
        ...(tipoPlano === 'AVANCADO' ? [{
            field: 'usaApp',
            headerName: 'App do Locatário',
            flex: 0.8,
            minWidth: 130,
            renderCell: (params: any) => {
                const usaApp = params.row.usaApp;
                const ultimoLogin = params.row.ultimoLoginApp;
                const tooltipText = usaApp && ultimoLogin
                    ? `Último login: ${new Date(ultimoLogin).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
                    : usaApp ? 'Ainda não acessou o app' : 'Não possui login no app';

                const label = usaApp ? 'Usa' : 'Não usa';
                const backgroundColor = usaApp ? '#4CAF50' : '#9e9e9e';

                return (
                    <Tooltip title={tooltipText} arrow>
                        <span style={{
                            backgroundColor,
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '5px',
                            fontWeight: 'bold',
                            fontSize: '0.75rem',
                            whiteSpace: 'nowrap',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            cursor: 'default',
                        }}>
                            <FaMobileAlt style={{ fontSize: '0.8rem' }} />
                            {label}
                        </span>
                    </Tooltip>
                );
            }
        }] : []),
        {
            field: 'observacaoInativacao', headerName: 'Observação', flex: 1,
            renderCell: (params: any) => {
                if (params.row.status !== StatusLocatario.stInativo) return '';
                return params.value || '';
            }
        },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ];

    const formatarData = (valor: any) => {
        if (!valor) return '';
        const data = new Date(valor);
        return isNaN(data.getTime()) ? '' : data.toLocaleDateString('pt-BR');
    };

    // Nomes de coluna iguais aos da importação (CAMPOS_LOCATARIO em services/importacao.ts): a planilha
    // exportada precisa voltar inteira pela importação (DL-169).
    const exportOptions = [
        { field: 'nome', headerName: 'Nome' },
        {
            field: 'tipoDocumento', headerName: 'Tipo Documento',
            valueGetter: ({ row }: { row: any }) => row.tipoDocumento === 2 ? 'CNPJ' : 'CPF'
        },
        { field: 'documento', headerName: 'Documento' },
        { field: 'rg', headerName: 'RG' },
        { field: 'numeroRegistroCnh', headerName: 'Número CNH' },
        {
            field: 'vencimentoHabilitacao', headerName: 'Vencimento Habilitação',
            valueGetter: ({ row }: { row: any }) => formatarData(row.vencimentoHabilitacao)
        },
        { field: 'telefone', headerName: 'Telefone' },
        { field: 'telefoneReserva', headerName: 'Telefone Reserva' },
        { field: 'email', headerName: 'Email' },
        { field: 'kmMedioPorDia', headerName: 'KM Médio/Dia' },
        { field: 'cep', headerName: 'CEP' },
        { field: 'estado', headerName: 'Estado' },
        { field: 'cidade', headerName: 'Cidade' },
        { field: 'logradouro', headerName: 'Logradouro' },
        { field: 'numero', headerName: 'Número' },
        { field: 'bairro', headerName: 'Bairro' },
        { field: 'complemento', headerName: 'Complemento' },
        {
            field: 'status', headerName: 'Status',
            valueGetter: ({ row }: { row: any }) => converterStatusLocatarioParaTexto(row.status) ?? 'Indefinido'
        },
        ...(tipoPlano === 'AVANCADO' ? [{
            field: 'usaApp', headerName: 'App do Locatário',
            valueGetter: ({ row }: { row: any }) => row.usaApp ? 'Usa' : 'Não usa'
        }] : []),
        {
            field: 'dataCadastro', headerName: 'Data de Cadastro',
            valueGetter: ({ row }: { row: any }) => formatarData(row.dataCadastro)
        },
        {
            field: 'observacaoInativacao', headerName: 'Observação',
            valueGetter: ({ row }: { row: any }) => row.status === StatusLocatario.stInativo ? (row.observacaoInativacao || '') : ''
        },
        ...(empresaTemFiliais ? [{
            field: 'idFilial', headerName: 'Unidade',
            valueGetter: ({ row }: { row: any }) => filiaisOptions.find((f: any) => f.valor === row.idFilial)?.label || ''
        }] : []),
    ];

    const pages = [
        {
            titulo: "Identificação",
            campos: ["idFilial", "_lerCnh", "nome", "tipoDocumento", "documento", "rg", "vencimentoHabilitacao", "numeroRegistroCnh", "kmMedioPorDia"]
        },
        {
            titulo: "Contato",
            campos: ["email", "telefone", "telefoneReserva", "_toggleAvancadoLocatario", "_labelCartao", "cartaoNomeTitular", "cartaoDocumentoTitular", "cartaoBandeira", "cartaoUltimos4Digitos", "cartaoValidade"]
        },
        {
            titulo: "Endereço",
            campos: ["cep", "estado", "cidade", "logradouro", "numero", "bairro", "complemento"]
        },
        {
            titulo: "Documento",
            campos: ["documentoCNH"]
        }
    ];

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6 });

    // Cadastro pela CNH: a IA lê a foto ou o PDF e os campos ficam preenchidos para conferência.
    // Pelo ref, o componente do campo é um só e não remonta no meio da leitura.
    const preencherPelaCnhRef = useRef<(cnh: CnhLida, alterar: (campo: string, valor: any) => void) => void>(() => { });
    preencherPelaCnhRef.current = (cnh, alterar) => {
        if (cnh.nome) alterar('nome', cnh.nome);
        if (cnh.cpf) {
            setMascaraDocumento('999.999.999-99');
            setIsPessoaJuridica(false);
            alterar('tipoDocumento', 1);
            alterar('documento', formatarCpf(cnh.cpf));
        }
        if (cnh.rg) alterar('rg', cnh.rg);
        if (cnh.numeroRegistro) alterar('numeroRegistroCnh', cnh.numeroRegistro.slice(0, 11));
        const validade = validadeCnhParaIso(cnh.validade);
        if (validade) alterar('vencimentoHabilitacao', validade);
    };
    const CampoLerCnh = useMemo(() => ({ handleInputChange }: { handleInputChange?: (campo: string, valor: any) => void }) => (
        <BotaoLerCnh aoLer={cnh => preencherPelaCnhRef.current(cnh, (campo, valor) => handleInputChange?.(campo, valor))} />
    ), []);

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        { label: '', nome: '_lerCnh', required: false, tipo: 'custom', largura: 12, coluna: 2, linha: 0, visible: modo === TipoFormulario.tpCadastro, component: CampoLerCnh },
        { label: 'Identificação:', nome: '', required: false, tipo: 'label', largura: 3, coluna: 1, linha: 1, visible: true, },
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 2, visible: true, tudoMaiusculo: true },
        {
            label: 'Tipo Documento', nome: 'tipoDocumento', required: true, tipo: 'select', largura: 4, coluna: 1, linha: 3, visible: true, opcoes: [{ label: 'CPF', valor: 1 }, { label: 'CNPJ', valor: 2 }], onCampoDigitar(e) {
                if (e == 1) {
                    setMascaraDocumento('999.999.999-99');
                    setIsPessoaJuridica(false);
                } else {
                    setMascaraDocumento('99.999.999/9999-99');
                    setIsPessoaJuridica(true);
                }
            },
        },
        { label: 'Documento', nome: 'documento', required: true, tipo: 'text', largura: 4, coluna: 2, linha: 3, visible: true, mascara: mascaraDocumento },
        { label: 'Rg', nome: 'rg', required: !isPessoaJuridica, tipo: 'text', largura: 4, coluna: 2, linha: 3, visible: true, },
        { label: 'Contato:', nome: '', required: false, tipo: 'label', largura: 3, coluna: 1, linha: 3, visible: true, },
        { label: 'Email', nome: 'email', required: false, tipo: 'email', largura: 6, coluna: 1, linha: 4, visible: true, tudoMaiusculo: false },
        { label: 'Telefone', nome: 'telefone', required: true, tipo: 'text', largura: 3, coluna: 2, linha: 4, visible: true, mascara: '(99) 99999-9999' },
        { label: 'Telefone Reserva', nome: 'telefoneReserva', required: false, tipo: 'text', largura: 3, coluna: 3, linha: 4, visible: true, mascara: '(99) 99999-9999' },
        {
            label: '', nome: '_toggleAvancadoLocatario', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 5,
            component: () => (
                <button
                    type="button"
                    onClick={() => {
                        const novoValor = !mostrarAvancadoLocatario;
                        setMostrarAvancadoLocatario(novoValor);
                        if (novoValor && !locatarioSelecionado?.cartaoNomeTitular) {
                            setEntidadeParaAtualizarNoModal({
                                cartaoNomeTitular: locatarioSelecionado?.nome || '',
                                cartaoDocumentoTitular: locatarioSelecionado?.documento || '',
                            });
                            setForcarAtualizacaoDeEntidadeNoModal(true);
                        }
                    }}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '0.9rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoLocatario ? 'Ocultar opções avançadas' : 'Opções avançadas'}
                </button>
            ),
        },
        { label: 'Cartão de Crédito:', nome: '_labelCartao', required: false, tipo: 'label', largura: 12, coluna: 1, linha: 6, visible: () => mostrarAvancadoLocatario },
        { label: 'Nome do Titular', nome: 'cartaoNomeTitular', required: false, tipo: 'text', largura: 6, coluna: 1, linha: 7, visible: () => mostrarAvancadoLocatario, tudoMaiusculo: true },
        { label: 'CPF/CNPJ do Titular', nome: 'cartaoDocumentoTitular', required: false, tipo: 'text', largura: 6, coluna: 2, linha: 7, visible: () => mostrarAvancadoLocatario },
        { label: 'Bandeira', nome: 'cartaoBandeira', required: false, tipo: 'select', largura: 4, coluna: 1, linha: 8, visible: () => mostrarAvancadoLocatario, opcoes: [{ label: 'Visa', valor: 'Visa' }, { label: 'Mastercard', valor: 'Mastercard' }, { label: 'Elo', valor: 'Elo' }, { label: 'Amex', valor: 'Amex' }, { label: 'Hipercard', valor: 'Hipercard' }, { label: 'Outro', valor: 'Outro' }] },
        { label: 'Últimos 4 Dígitos', nome: 'cartaoUltimos4Digitos', required: false, tipo: 'text', largura: 3, coluna: 2, linha: 8, visible: () => mostrarAvancadoLocatario, mascara: '9999' },
        { label: 'Validade (MM/AA)', nome: 'cartaoValidade', required: false, tipo: 'text', largura: 5, coluna: 3, linha: 8, visible: () => mostrarAvancadoLocatario, mascara: '99/99' },
        { label: 'Endereço:', nome: '', required: false, tipo: 'label', largura: 6, coluna: 2, linha: 7, visible: true, },
        {
            label: 'CEP', nome: 'cep', required: true, tipo: 'text', largura: 4, coluna: 1, linha: 6, visible: true, mascara: '99999-999', onCampoSair(e) {
                let cep = e.replace(/\D/g, '');
                if (cep.length == 8) {
                    buscarPorCep(e);
                }
            }, botaoExtra: { icone: FaSearchLocation, link: 'https://buscacepinter.correios.com.br/app/endereco/index.php', tooltip: 'Encontrar CEP' }
        },
        {
            label: 'Estado', nome: 'estado', required: true, tipo: 'select', largura: 4, coluna: 2, linha: 6, visible: true, opcoes: estados, onCampoSair(e) {
                if (e != estado) {
                    setEstado(e);
                }
            }, allowNotFoundValues: true
        },
        { label: 'Cidade', nome: 'cidade', required: true, tipo: 'select', largura: 4, coluna: 3, linha: 6, visible: true, opcoes: cidades, carregando: carregandoSelectCidades, allowNotFoundValues: true },
        { label: 'Logradouro', nome: 'logradouro', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 7, visible: true, },
        { label: 'Numero', nome: 'numero', required: true, tipo: 'text', largura: 6, coluna: 2, linha: 7, visible: true, },
        { label: 'Bairro', nome: 'bairro', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 8, visible: true, allowNotFoundValues: true },
        { label: 'Complemento', nome: 'complemento', required: false, tipo: 'text', largura: 6, coluna: 2, linha: 8, visible: true, },
        { label: 'Informações adicionais:', nome: '', required: false, tipo: 'label', largura: 6, coluna: 2, linha: 9, visible: true, },
        { label: 'Vencimento Habilitação', nome: 'vencimentoHabilitacao', required: !isPessoaJuridica, tipo: 'date', largura: 4, coluna: 1, linha: 10, visible: true, },
        { label: 'Número de Registro CNH', nome: 'numeroRegistroCnh', required: false, tipo: 'text', largura: 4, coluna: 2, linha: 10, visible: true, maximoCaracteres: 11 },
        { label: 'Documento CNH', nome: 'documentoCNH', required: false, tipo: 'file', largura: 12, coluna: 1, linha: 11, visible: true, maximoCaracteres: 11 },
        {
            label: 'Km médio / Dia', nome: 'kmMedioPorDia', required: false, tipo: 'number', largura: 4, coluna: 3, linha: 10, visible: true, ajudinha: {
                texto: "Esse campo se refere a quantos quilometros em média um locatário roda por dia. Normalmente se usa uma estimativa de 110~200 quilometros por dia", autoCloseTime: 3
            }
        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 11, visible: false, tudoMaiusculo: true },
    ];

    const camposLoginLocatario: Campo[] = [
        { label: 'Email', nome: 'email', required: true, tipo: 'email', largura: 6, coluna: 1, linha: 1, visible: true, },
        { label: 'Senha', nome: 'senha', required: true, tipo: 'senha', largura: 6, coluna: 2, linha: 1, visible: true, },
    ];

    const temPermissao = usuarioTemPermissao(token, 'locatario_visualizar');

    useEffect(() => {
        const carregarTipoPlano = async () => {
            if (!token) return;

            try {
                const plano = await obterTipoPlano(token);
                setTipoPlano((plano as 'PRO' | 'AVANCADO') || 'PRO');
            } catch {
                setTipoPlano('PRO');
            }
        };

        carregarTipoPlano();
    }, [token]);

    useEffect(() => {
        const carregarConfiguracaoAsaas = async () => {
            if (!token) return;

            try {
                const res = await api.get(`/AsaasIntegrado/${obterIdTenent(token)}`);
                setIntegradoAsaas(res.data === true);
            } catch {
                setIntegradoAsaas(false);
            }
        };

        carregarConfiguracaoAsaas();
    }, [token]);

    const sincronizarLocatarioComAsaas = async (entidade: Locatario) => {
        if (!entidade?.id) return;
        if (sincronizandoAsaasId) return;

        setSincronizandoAsaasId(entidade.id);
        try {
            const response = await api.post(`/Locatario/SincronizarAsaas/${entidade.id}`);
            const resultado = response.data;
            const mensagem: string = resultado?.mensagem || 'Sincronização concluída.';

            switch (resultado?.status) {
                case 0:
                    toast.warning(mensagem);
                    break;
                case 1:
                case 4:
                    toast.success(mensagem);
                    setRealizarConsulta(true);
                    break;
                case 2:
                    toast.info(mensagem);
                    break;
                case 3:
                    toast.success(mensagem);
                    break;
                default:
                    toast.info(mensagem);
            }
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setSincronizandoAsaasId(null);
        }
    };

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        setIsSubmiting(false);
        setDocumentoCNHRemovido(false);
        setIsSavingLoginLocatario(false);
        toast.error('Não foi possível continuar a operação Locatário: ' + error.response?.data.Mensagem)
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleCadastrar = () => {
        if (usuarioTemPermissao(token, 'locatario_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setLocatarioSelecionado({} as Locatario);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo locatário')
        }
    }

    const handleEditar = (Locatario: any) => {
        if (usuarioTemPermissao(token, 'locatario_editar')) {
            setModo(TipoFormulario.tpEdicao)
            setLocatarioSelecionado(Locatario);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar um locatário')
        }
    }

    const handleExclusao = async (Locatario: Locatario) => {
        if (usuarioTemPermissao(token, 'locatario_excluir')) {
            setCarregando(true);
            await api.delete(`/Locatario/${Locatario.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Locatário foi excluído com sucesso')
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = (Locatario: any) => {
        if (usuarioTemPermissao(token, 'locatario_visualizar')) {
            setLocatarioSelecionado(Locatario);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao)
        }
    }

    const obterIdLocatario = () => {
        const searchParams = new URLSearchParams(location.search);
        const idLocatario = searchParams.get('id');
        return idLocatario;
    }

    const obterParametroCriarAcesso = () => {
        const searchParams = new URLSearchParams(location.search);
        const criarAcesso = searchParams.get('CriarAcesso');
        return criarAcesso;
    }

    useEffect(() => {
        setRealizarConsulta(true);
    }, [paginationModel, location.search]);

    useEffect(() => {
        const fetchLocatariosPorEmpresa = async () => {
            if ((temPermissao) && (realizarConsulta)) {
                setCarregando(true);
                const idLocatario = obterIdLocatario();
                const criarAcesso = obterParametroCriarAcesso();
                const searchParams = new URLSearchParams(location.search);
                const searchTerm = searchParams.get('search') || "";

                if (idLocatario || criarAcesso) {
                    const idParaBuscar = idLocatario || criarAcesso;
                    await api.get(`/Locatario/${idParaBuscar}`)
                        .then(response => {
                            setTimeout(() => {
                                const locatario = response.data;
                                setLocatarios(Array.isArray(locatario) ? locatario : [locatario]);
                                setRealizarConsulta(false);
                                setCarregando(false);
                                setRowCount(1);

                                if (criarAcesso) {
                                    setLocatarioSelecionado(locatario);
                                    CriarEditarLoginNoApp(locatario);
                                }
                            }, 250);
                        }).catch((error: AxiosError<ApiError>) => {
                            tratarErro(error);
                        });
                } else {
                    const pageToSend = paginationModel.page + 1;
                    let url = `/LocatariosPorEmpresaComArquivosPaginado/${obterIdTenent(token)}?page=${pageToSend}&pageSize=${paginationModel.pageSize}`;
                    
                    if (searchTerm) {
                        url += `&termoBusca=${encodeURIComponent(searchTerm)}`;
                    }

                    await api.get(url)
                        .then(response => {
                            setTimeout(() => {
                                if (response.data.items) {
                                    setLocatarios(response.data.items);
                                    setRowCount(response.data.totalCount);
                                } else {
                                    // Fallback caso a API não retorne estrutura paginada (ex: erro ou versão antiga em cache)
                                    setLocatarios(response.data);
                                    setRowCount(response.data.length);
                                }
                                setRealizarConsulta(false);
                                setCarregando(false);
                            }, 250);
                        }).catch((error: AxiosError<ApiError>) => {
                            tratarErro(error);
                        });
                }
            }
        }

        fetchLocatariosPorEmpresa();
    }, [temPermissao, realizarConsulta, token, location.search, paginationModel]);

    // Removed the second useEffect duplicate


    const buscarPorCep = async (cep: string) => {
        try {
            const apiGenerica = axios.create({ baseURL: 'https://viacep.com.br/ws/' });
            cep = cep.replace(/\D/g, '');
            let endPoint = `${cep}/json/`;

            const response = await apiGenerica.get(endPoint);
            const infoCep = response.data;
            const camposAtualizados = {
                logradouro: infoCep.logradouro,
                bairro: infoCep.bairro,
                cidade: infoCep.localidade,
                estado: infoCep.uf,
            };

            setEntidadeParaAtualizarNoModal(camposAtualizados);
            await buscarCidades(camposAtualizados.estado);
            setForcarAtualizacaoDeEntidadeNoModal(true);
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const buscarCidades = async (codigoEstado: string) => {
        if (codigoEstado) {
            setCarregandoSelectCidades(true);

            const apiGenerica = axios.create({ baseURL: 'https://brasilapi.com.br/api/' });
            let endPoint = `ibge/municipios/v1/${codigoEstado}`;

            apiGenerica.get(endPoint).then((response) => {
                const novasOpcoes = response.data.map((cidade: any) => ({
                    codigo: cidade.nome,
                    valor: cidade.nome,
                    label: cidade.nome,
                }));

                setCidades(novasOpcoes);
                setCarregandoSelectCidades(false);
            }).catch(tratarErro);
        }
    }

    useEffect(() => {
        if (estado) {
            buscarCidades(estado);
        }
    }, [estado]);

    const handleShowModal = async () => {
        setEstados([]);
        setCidades([]);

        setCarregando(true);

        const novasOpcoes = ESTADOS_BRASIL.map((uf) => ({
            codigo: uf.sigla,
            valor: uf.sigla,
            label: uf.nome,
        }));

        setEstados(novasOpcoes);
        setCarregando(false);

        if (modo !== TipoFormulario.tpEdicao && modo !== TipoFormulario.tpVisualizacao) return;

        const apiGenerica = axios.create({ baseURL: 'https://brasilapi.com.br/api/' });
        let endPointCidades = `ibge/municipios/v1/${locatarioSelecionado.estado}`;

        if (locatarioSelecionado.estado) {
            setCarregando(true);
            await apiGenerica.get(endPointCidades).then((response) => {
                const novasOpcoes = response.data.map((cidade: any) => ({
                    codigo: cidade.nome,
                    valor: cidade.nome,
                    label: cidade.nome,
                }));

                setCidades(novasOpcoes);
                setCarregando(false);
            }).catch(tratarErro);
        }

        if (locatarioSelecionado) {
            let tipoDocumento = locatarioSelecionado.tipoDocumento || 1;

            if (tipoDocumento == 1) {
                setMascaraDocumento('999.999.999-99');
                setIsPessoaJuridica(false);
            } else {
                setMascaraDocumento('99.999.999/9999-99');
                setIsPessoaJuridica(true);
            }
        }
    }

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModal) {
            setForcarAtualizacaoDeEntidadeNoModal(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModal]);

    useEffect(() => {
        const fetchBuscarCidades = async (estado: any) => {
            if (locatarioSelecionado) {
                if (estado) {
                    if (modo != TipoFormulario.tpNenhum) {
                        await buscarCidades(estado);
                    }
                }
            }
        }

        fetchBuscarCidades(estado);
    }, [estado, modo, locatarioSelecionado]);

    // Ações que a API restringe: status e Asaas exigem locatario_editar; o acesso ao app é consultado com usuario_visualizar.
    const acoesDoLocatarioPermitidas: Record<string, boolean> = {
        'Sincronizar com Asaas': usuarioTemPermissao(token, 'locatario_editar'),
        'Ativar/Inativar': usuarioTemPermissao(token, 'locatario_editar'),
        'Login no APP': usuarioTemPermissao(token, 'usuario_visualizar'),
    };

    const mudarStatusDoLocatario = async (locatario: Locatario) => {
        const status = locatario.status as unknown as StatusLocatario;

        if (status == StatusLocatario.stHabilitacaoVencida) {
            toast.info('Este locatário está com a Habilitação Vencida, portanto, não é possível alterar seu status.')
            return;
        }

        const vaiInativar = status !== StatusLocatario.stInativo;
        if (vaiInativar) {
            setLocatarioParaInativar(locatario);
            setExibirModalInativar(true);
            return;
        }

        try {
            await api.put(`/Locatario/AtualizarSatus?IdLocatario=${locatario.id}&status=${StatusLocatario.stAtivo}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            toast.success('Locatário ativado com sucesso');
            setRealizarConsulta(true);
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const confirmarInativacaoLocatario = async (entidade: any) => {
        if (!locatarioParaInativar) return;
        try {
            await api.put(`/Locatario/AtualizarSatus?IdLocatario=${locatarioParaInativar.id}&status=${StatusLocatario.stInativo}`,
                { observacao: entidade?.observacaoInativacao || null },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            toast.success('Locatário inativado com sucesso');
            setExibirModalInativar(false);
            setLocatarioParaInativar(null);
            setRealizarConsulta(true);
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Locatário salvo com sucesso')
        setFezAlgumaAcao(true);
    }

    const chamarWhatsapp = async (numero: string, mensagem?: string) => {
        numero = numero.replace(/\D/g, '');
    
        let url = `https://wa.me/55${numero}`;
    
        if (mensagem && mensagem.trim() !== '') {
            url += `?text=${encodeURIComponent(mensagem)}`;
        }
    
        window.open(url, '_blank');
    };
    

    const cnhNaoInformada = () => {
        toast.info('Esse locatário não possui o documento de CNH anexado no sistema.');
    }

    const naoFoiPossivelBaixarCNH = () => {
        toast.error('Não foi possível baixar a CNH desse locatário.');
    }

    const cnhBaixadaComSucesso = () => {
        toast.success('CNH Baixada com sucesso');
    }

    const baixarCNH = async (entidade: any) => {
        handleDownloadFile(entidade.documentoCNH, `${entidade.nome}-CNH`, () => cnhNaoInformada(), () => cnhBaixadaComSucesso(), () => naoFoiPossivelBaixarCNH());
    }

    const CriarEditarLoginNoApp = async (entidade: any) => {
        setLocatarioSelecionado(entidade);
        
        setEntidadeUsada({} as any); 
        
        setIsSavingLoginLocatario(true);
        setShowLoginLocatario(true);

        api.get(`/UsuarioLocatario/${entidade.id}`)
            .then(response => {
                setTimeout(() => {
                    setEntidadeUsada({ 
                        email: response.data.email, 
                        senha: response.data.senha, 
                        id: response.data.id 
                    });
                    setForcarAtualizacao(true); // Atualiza com dados encontrados
                }, 250);
            })
            .catch((error: AxiosError<ApiError>) => {
                if (error.response?.status === 404) {
                    setEntidadeUsada({} as any);
                    setForcarAtualizacao(true);
                } else {
                    tratarErro(error);
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setIsSavingLoginLocatario(false);
                }, 250);
            });
    }

    const onSave = useCallback(async (entidade: any) => {
        if (isSubmiting) return;

        setIsSubmiting(true);

        if (!usuarioTemPermissao(token, 'locatario_novo') && !usuarioTemPermissao(token, 'locatario_editar')) {
            setIsSubmiting(false);
            return;
        }

        try {
            const locatario = {
                bairro: entidade.bairro,
                cep: entidade.cep,
                cidade: entidade.cidade,
                complemento: entidade.complemento,
                dataCadastro: new Date().toDateString(),
                documento: entidade.documento,
                email: entidade.email,
                estado: entidade.estado,
                idEmpresa: obterIdTenent(token),
                kmMedioPorDia: entidade.kmMedioPorDia || 110,
                logradouro: entidade.logradouro,
                nome: entidade.nome,
                numero: entidade.numero,
                telefone: entidade.telefone,
                telefoneReserva: entidade.telefoneReserva,
                vencimentoHabilitacao: entidade.vencimentoHabilitacao,
                numeroRegistroCnh: entidade.numeroRegistroCnh,
                tipoDocumento: entidade.tipoDocumento,
                rg: entidade.rg || '',
                ...(entidade.idFilial && { idFilial: entidade.idFilial }),
                ...(modo === TipoFormulario.tpEdicao && { id: entidade.id })
            };

            const dadosASalvar = new FormData();

            Object.entries(locatario).forEach(([key, value]) => {
                dadosASalvar.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
            });

            if (entidade.documentoCNH) dadosASalvar.append("documentoCNH", entidade.documentoCNH);

            const documentoCNHRemoved = documentoCNHRemovido && !entidade.imagem;

            dadosASalvar.append("removerDocumentoCNH", String(documentoCNHRemoved));

            await (modo === TipoFormulario.tpCadastro ? api.post : api.put)(
                `/locatario/ComDocumentoCNH`,
                dadosASalvar,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            );

            setTimeout(() => {
                setRealizarConsulta(true);
                setExibirFormModal(false);
                toast.success('Locatário salvo com sucesso');
                setIsSubmiting(false);
                setDocumentoCNHRemovido(false);
            }, 250);

        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
            setIsSubmiting(false);
        }
    }, [
        isSubmiting,
        token,
        modo,
        documentoCNHRemovido
    ]);

    const onSaveLoginLocatario = useCallback(async (entidade: any) => {
        if (isSavingLoginLocatario) return;

        setIsSavingLoginLocatario(true);

        if (!usuarioTemPermissao(token, 'locatario_novo') && !usuarioTemPermissao(token, 'locatario_editar')) {
            setIsSavingLoginLocatario(false);
            toast.error('Você não tem permissão para essa operação.');
            return;
        }

        const UsuarioLocatario: UsuarioLocatario = {
            nome: locatarioSelecionado.nome,
            email: entidade.email,
            senha: entidade.senha,
            idEmpresa: obterIdTenent(token),
            idLocatario: locatarioSelecionado.id || '',
            ...(modo === TipoFormulario.tpEdicao && { id: entidade.id })
        };

        const linkAndroid = 'https://play.google.com/store/apps/details?id=com.locasmartpro.gestaodelocadoras&pcampaignid=web_share';
        const linkIOS = 'https://apps.apple.com/br/app/locasmartpro-app-locatário/id6757689416';

        try {
            if (entidadeUsada.id) {
                UsuarioLocatario.id = entidadeUsada.id;
                await api.put('/UsuarioLocatario/', UsuarioLocatario, {
                    headers: { 'Content-Type': 'application/json' },
                });
            } else {
                await api.post('/UsuarioLocatario/', UsuarioLocatario, {
                    headers: { 'Content-Type': 'application/json' },
                });
            }

            toast.success('Usuário do Locatário salvo com sucesso');

            try {
                const links = `Android: ${linkAndroid}\niOS: ${linkIOS}`;
                await navigator.clipboard.writeText(links);
                toast.info('Links do app (Android e iOS) copiados para a área de transferência!', { autoClose: 15000 });
            } catch {
                toast.warning('Não foi possível copiar os links automaticamente');
            }

            handleFecharModalLogin();
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setIsSavingLoginLocatario(false);
        }
    }, [
        token,
        modo,
        locatarioSelecionado,
        isSavingLoginLocatario
    ]);


    useEffect(() => {
        if (forcarAtualizacao) {
            setForcarAtualizacao(false);
        }
    }, [forcarAtualizacao]);

    const handleFecharModalLogin = () => {
        setShowLoginLocatario(false);
        const url = new URL(window.location.href);
        url.searchParams.delete('CriarAcesso');
        window.history.replaceState({}, '', url.toString());
    }

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('locatario')}
                    colunas={colunas}
                    linhas={locatarios}
                    exportOptions={exportOptions}
                    nomeEntidade="Locatário"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={FaUser}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setLocatarioSelecionado}
                    acoesExtras={
                        ocultarAcoes([...(integradoAsaas ? [{
                            Icone: FaSync,
                            OnClick: (entidade: Locatario) => sincronizarLocatarioComAsaas(entidade),
                            Texto: 'Sincronizar com Asaas',
                            Cor: '#1F467E'
                        }] : []),
                        {
                            Icone: FaExchangeAlt, OnClick: (entidade) => {
                                mudarStatusDoLocatario(entidade)
                            }, Texto: 'Ativar/Inativar'
                        },
                        {
                            Icone: FaIdCard, OnClick: (entidade) => {
                                baixarCNH(entidade)
                            }, Texto: 'Baixar CNH',
                        },
                        {
                            Icone: FaWhatsapp, OnClick: (entidade) => {
                                chamarWhatsapp(entidade.telefone)
                            }, Texto: 'WhatsApp', Cor: 'green'
                        },
                        {
                            Icone: FaUser, OnClick: (entidade) => {
                                if (tipoPlano === 'AVANCADO' || estaEmPeriodoDeTeste(token)) {
                                    CriarEditarLoginNoApp(entidade)
                                } else {
                                    toast.info("Funcionalidade disponível apenas no plano Avançado.");
                                }
                            }, Texto: 'Login no APP',
                        },
                        {
                            Icone: FaLink, OnClick: async (entidade) => {
                                if (tipoPlano === 'AVANCADO' || estaEmPeriodoDeTeste(token)) {
                                    const linkAndroid = 'https://play.google.com/store/apps/details?id=com.locasmartpro.gestaodelocadoras&pcampaignid=web_share';
                                    const linkIOS = 'https://apps.apple.com/br/app/locasmartpro-app-locatário/id6757689416';
                                    const mensagem = `Links para o APP:\nAndroid: ${linkAndroid}\niOS: ${linkIOS}`;
                                    try {
                                        await navigator.clipboard.writeText(mensagem);
                                        chamarWhatsapp(entidade.telefone, mensagem)
                                        toast.info('Links do app (Android e iOS) copiados para a área de transferência!', { autoClose: 10000 });
                                    } catch {
                                        toast.warning('Não foi possível copiar os links automaticamente');
                                    }
                                } else {
                                    toast.info("Funcionalidade disponível apenas no plano Avançado.");
                                }

                            }, Texto: 'Enviar Link APP',
                        }
                        ], acoesDoLocatarioPermitidas)}
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    paginationMode="server"
                    onImportar={() => setShowModalImportacao(true)}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('Locatario', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('Locatario', () => setRealizarConsulta(true))!] : []),
                    ]}
                    headerExtra={integradoLocaSmartCheck ? (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <button
                                onClick={() => setModalSincLocaSmartCheckAberto(true)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: 6,
                                    padding: '4px 12px', borderRadius: 20,
                                    border: '1.5px solid #2e7d32', backgroundColor: '#e8f5e9',
                                    cursor: 'pointer', fontSize: 13, fontWeight: 600,
                                    color: '#1b5e20', transition: 'all 0.2s',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#c8e6c9'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#e8f5e9'; }}
                                title="Migrar locatários ainda não cadastrados no LocaSmartCheck"
                            >
                                <FaSyncAlt size={14} />
                                Sincronizar com LocaSmartCheck
                            </button>
                        </Box>
                    ) : undefined}
                    tituloExportacao="Locatarios"
                    onExportarBuscarTudo={async () => {
                        const searchParams = new URLSearchParams(location.search);
                        const searchTerm = searchParams.get('search') || "";
                        let url = `/LocatariosPorEmpresaComArquivosPaginado/${obterIdTenent(token)}?page=1&pageSize=100000`;
                        if (searchTerm) url += `&termoBusca=${encodeURIComponent(searchTerm)}`;
                        const response = await api.get(url);
                        return response.data?.items ?? response.data ?? [];
                    }}
                />

                <ModalSincronizacao
                    open={modalSincLocaSmartCheckAberto}
                    onClose={() => {
                        setModalSincLocaSmartCheckAberto(false);
                        setRealizarConsulta(true);
                    }}
                    abasVisiveis={['locatarios']}
                    titulo="Migrar locatários para o LocaSmartCheck"
                />

                <ModalImportacao
                    show={showModalImportacao}
                    onHide={() => setShowModalImportacao(false)}
                    titulo="Importar Locatários"
                    campos={CAMPOS_LOCATARIO}
                    nomeTemplate="template-locatarios"
                    camposFixos={{ idEmpresa: obterIdTenent(token), dataCadastro: new Date().toISOString() }}
                    enviar={async (item) => { await api.post('/Locatario', item); }}
                    permitirAtualizacao
                    chaveMatch="documento"
                    rotuloCampo="nome"
                    buscarExistentes={async () => {
                        const resp = await api.get(`/LocatariosPorEmpresa/${obterIdTenent(token)}`);
                        return resp.data || [];
                    }}
                    atualizar={async (item) => { await api.put('/Locatario', item); }}
                    onImportacaoConcluida={() => setRealizarConsulta(true)}
                />

                <ModalForm
                    pages={pages}
                    modo={modo}
                    tamanho="lg"
                    onSave={onSave}
                    isSaving={isSubmiting}
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onShow={handleShowModal}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    planoPremium={(!ehPlanoGratuito(token) && !estaEmPeriodoDeTeste(token))}
                    ajudinha={
                        {
                            texto: "Aqui você poderá cadastrar locatários que serão utilizados em movimentações, como a de locações de veículos. Esses cadastros facilitam a seleção nas telas de movimentação, garantindo uma escolha rápida e a padronização das operações.",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={locatarioSelecionado}
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: entidadeParaAtualizarNoModal,
                            forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal
                        }
                    }
                    apiConfig={
                        {
                            endpoint: "locatario/ComDocumentoCNH",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                    onFileRemoved={(campo: string) => {
                        setDocumentoCNHRemovido(true);
                    }}
                />

                <ModalForm
                    modo={TipoFormulario.tpCadastro}
                    tamanho="lg"
                    campos={camposLoginLocatario}
                    onSave={onSaveLoginLocatario}
                    show={showLoginLocatario}
                    carregando={isSavingLoginLocatario}
                    onHide={handleFecharModalLogin}
                    onCancel={handleFecharModalLogin}
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: entidadeUsada,
                            forcarAtualizacao: forcarAtualizacao
                        }
                    }
                    isSaving={isSavingLoginLocatario}
                    titulo="Criar/Editar Login do Locatário no App"
                    tituloBotaoOk="Salvar"
                    apiConfig={
                        {
                            endpoint: 'usuariolocatario',
                            idTenentCampo: 'idEmpresa',
                            requisicaoBemSucedida: () => { },
                            tratarErro: tratarErro,
                        }
                    }
                />

                <ModalForm
                    modo={TipoFormulario.tpCadastro}
                    tamanho="lg"
                    titulo="Inativar Locatário"
                    tituloBotaoOk="Inativar"
                    campos={[
                        { label: 'Observação (opcional)', nome: 'observacaoInativacao', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 1, visible: true },
                    ]}
                    onSave={confirmarInativacaoLocatario}
                    show={exibirModalInativar}
                    carregando={carregando}
                    onHide={() => { setExibirModalInativar(false); setLocatarioParaInativar(null); }}
                    onCancel={() => { setExibirModalInativar(false); setLocatarioParaInativar(null); }}
                    entidadeSelecionada={{}}
                    apiConfig={{
                        endpoint: "locatario",
                        requisicaoBemSucedida: () => { },
                        tratarErro: () => { },
                        idTenentCampo: 'idEmpresa',
                    }}
                />
            </LocaSmartLayout>
        </>
    );
}

export default LocatarioListagem;